import { Playfair_Display } from "next/font/google";
const inch = 14;
const tierHeight = 5 * inch; // Fixed height for each tier

const CakeTier = ({ diameter, type, servingSize }) => {
  const style = {
    width: `${diameter * inch}px`, // Scale the size for display
    height: `${tierHeight}px`,
    backgroundColor: "#c2c2c2",
    color: "#fff",
    fontSize: "1rem",
    fontWeight: "400",
    display: "flex",
    justifyContent: "center", // Horizontally center the content
    alignItems: "center", // Vertically center the content
    margin: "1px auto",
  };

  return <div style={style}>{diameter}&quot;</div>;
};

// CakeStand.js
const CakeStand = ({ diameter }) => {
  return (
    <div style={{ textAlign: "center", position: "relative" }}>
      <div className="stand-leg"></div>
      <div className="stand-bottom"></div>
    </div>
  );
};

// CakeTiers.js
const CakeTiers = ({ combinations, type, servingSize, showPrice }) => {
  return (
    <div className="container grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-20 lg:gap-10">
      {combinations.map((combo, index) => {
        const { combination, totalPrice } = combo;
        const tierCount =
          combination.length > 1
            ? combination.length + " Tiers"
            : combination.length + " Tier";

        // Calculate the total servings for the combination
        const totalServings = combination.reduce((acc, cake) => {
          return (
            acc + (servingSize === "1x2" ? cake.servings1x2 : cake.servings1x1)
          );
        }, 0);

        // Calculate the diameter for the stand based on the bottom tier
        const largestDiameter = Math.max(
          ...combination.map((cake) => cake.diameter)
        );
        return (
          <div
            key={index}
            className="combination"
            style={{
              minHeight: `${inch * combination.length}%`,
              marginBottom: "30px",
            }}
          >
            {combination.map((cake, tierIndex) => (
              <CakeTier key={tierIndex} diameter={cake.diameter} />
            ))}
            <CakeStand diameter={largestDiameter} />
            <div className="show-details text-sm mt-2 !text-slate-500">
              Up to {totalServings} servings
            </div>
            <div className="show-tier-count-price !font-serif font-normal">
              {" "}
              {tierCount}{" "}
            </div>
            {showPrice && (
              <div className="show-price">
                Starting from £{totalPrice.toFixed(0)}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CakeTiers;
